import { render, staticRenderFns } from "./TransViewMore.vue?vue&type=template&id=29208fe6&scoped=true"
import script from "./TransViewMore.vue?vue&type=script&lang=js"
export * from "./TransViewMore.vue?vue&type=script&lang=js"
import style0 from "./TransViewMore.vue?vue&type=style&index=0&id=29208fe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29208fe6",
  null
  
)

export default component.exports